import { CLAIMS_CLAIMDETAIL_SAVE_LOADING, CLAIMS_CLAIMDETAIL_SAVE_SUCCESS, CLAIMS_CLAIMDETAIL_SAVE_FAIL, CLAIMS_CLAIMDETAIL_LEAVECLAIM, CLAIMS_CLAIMDETAIL_LIFECYCLE, CLAIMS_CLAIMDETAIL_LOAD_DATA, CLAIMS_CLAIMDETAIL_LEAVEQUOTE, CLAIMS_CLAIMDETAIL_CLAIMANT, CLAIMS_CLAIMDETAIL_CLAIMITEM, CLAIMS_CLAIMDETAIL_PARAM, CLAIMS_CLAIMDETAIL_PARAM_NOL1, CLAIMS_CLAIMDETAIL_PARAM_RESERVE_LOADING, CLAIMS_CLAIMDETAIL_PARAM_RESERVE, CLAIMS_CLAIMDETAIL_PARAM_RESERVE_FAIL, CLAIMS_CLAIMDETAIL_RESERVE, CLAIMS_CLAIMDETAIL_CLAIMRESERVE } from '@/store/types'
import { formatServerTimeFormat } from '@/utils/date'
import { removeFormatNumber } from '@/utils/number'
import clone from 'clone'
import Vue from 'vue'

export const claim = {
  [CLAIMS_CLAIMDETAIL_SAVE_LOADING](state) {
    state.claimDetail.saving = true
    state.claimDetail.saveError.fieldMessages = []
    state.claimDetail.saveError.messages = []
  },
  [CLAIMS_CLAIMDETAIL_SAVE_SUCCESS](state) {
    state.claimDetail.saving = false
    state.claimDetail.saveError.fieldMessages = []
    state.claimDetail.saveError.messages = []
  },
  [CLAIMS_CLAIMDETAIL_SAVE_FAIL](state, errMsgs) {
    state.claimDetail.saving = false
    state.claimDetail.saveError.fieldMessages = errMsgs.fieldMessages
    state.claimDetail.saveError.messages = errMsgs.messages
  },
  [CLAIMS_CLAIMDETAIL_LEAVECLAIM](state) {
    state.claimDetail.promptWhenExit = false
  },
  [CLAIMS_CLAIMDETAIL_LOAD_DATA](state, fullData) {
    if (fullData.partialSave) {
      // For normal saving, we just want to update the revision no to prevent locking
      const { data } = fullData
      state.claimDetail.commonForm.revision = data.revision
    } else {
      const { data, query, menu } = fullData
      // General Data
      if (state.claimDetail.claimLifeCycle === 0 && !query) {
        state.claimDetail.claimLifeCycle = 1
      }
      commitIntClmhdr(state, data)
      commitIntClmtDet(state, data)
      // Menu (For query)
      if (menu) {
        state.claimEntry.menu = menu
      }
    }
  },
  [CLAIMS_CLAIMDETAIL_LIFECYCLE](state, data) {
    state.claimDetail.claimLifeCycle = data
  },
  [CLAIMS_CLAIMDETAIL_CLAIMANT](state, data) {
    if (data) {
      state.claimDetail.commonForm.reqDate = data.reqDate
      state.claimDetail.commonForm.recDate = data.recDate
      state.claimDetail.commonForm.lossPlace = data.lossPlace
      state.claimDetail.commonForm.cseLoss1 = data.cseLoss1
      state.claimDetail.commonForm.cseLoss2 = data.cseLoss2
      state.claimDetail.commonForm.cseLoss3 = data.cseLoss3
      // Claimants Information
      state.claimDetail.claimForm.claimants = clone(data.claimants)
      let seqNo = 1
      if (state.claimDetail.claimForm.claimants && state.claimDetail.claimForm.claimants.length > 0) {
        for (const claimant of state.claimDetail.claimForm.claimants) {
          claimant.clmtNo = seqNo
          if (claimant && claimant.clmtDob) {
            claimant.clmtDob = formatServerTimeFormat(claimant.clmtDob)
          }
          seqNo++
        }
      }
      if (data.selectedClaimant) {
        data.selectedClaimant.clmtNo = data.selectedClaimant.clmtNo + 1
        state.claimDetail.claimForm.selectedClaimant = data.selectedClaimant
      }
    }
  },
  [CLAIMS_CLAIMDETAIL_CLAIMITEM](state, data) {
    if (data) {
      // Update selected Claim Item Information
      if (data.selectedClmItem) {
        data.selectedClmItem.clmItemNo = data.selectedClmItem.clmItemNo + 1
        state.claimDetail.claimForm.selectedClmItem = data.selectedClmItem
      }

      // Assign Claim Items to selected Claimant and update back to Claimant List
      let seqNo = 1
      if (data.selectedClaimant) {
        if (data.clmItems && data.clmItems.length > 0) {
          for (const clmItem of data.clmItems) {
            clmItem.clmItemNo = seqNo
            seqNo++
          }
        }
        data.selectedClaimant.clmItems = clone(data.clmItems)
        state.claimDetail.claimForm.selectedClaimant = data.selectedClaimant
      }
      if (state.claimDetail.claimForm.claimants && state.claimDetail.claimForm.claimants.length > 0) {
        for (const claimant of state.claimDetail.claimForm.claimants) {
          if (claimant && claimant.clmtNo === state.claimDetail.claimForm.selectedClaimant.clmtNo) {
            claimant.clmItems = state.claimDetail.claimForm.selectedClaimant.clmItems
          }
        }
      }
    }
  },
  [CLAIMS_CLAIMDETAIL_RESERVE](state, data) {
    const reserveData = clone(data)
    if (reserveData && reserveData.length > 0) {
      for (let reserve of reserveData) {
        reserve.value = removeFormatNumber(reserve.value)
      }
    }
    state.claimDetail.claimForm.clmReserves = clone(reserveData)
  },
  [CLAIMS_CLAIMDETAIL_CLAIMRESERVE](state, data) {
    const reserveData = clone(data.submitReserve)
    if (reserveData && reserveData.length > 0) {
      for (let reserve of reserveData) {
        reserve.value = removeFormatNumber(reserve.value)
      }
    }
    // Update selected Claim Item Reserves
    if (data.selectedClmItem) {
      data.selectedClmItem.clmReserves = clone(reserveData)
      state.claimDetail.claimForm.selectedClmItem = data.selectedClmItem
    }

    if (data.selectedClaimant) {
      if (data.selectedClaimant.clmItems && data.selectedClaimant.clmItems.length > 0) {
        for (const clmtClmItem of data.selectedClaimant.clmItems) {
          if (clmtClmItem && clmtClmItem.clmtNo === data.selectedClmItem.clmtNo && clmtClmItem.clmItemNo === data.selectedClmItem.clmItemNo) {
            clmtClmItem.clmReserves = state.claimDetail.claimForm.selectedClmItem.clmReserves
          }
        }
      }
    }

    if (state.claimDetail.claimForm.claimants && state.claimDetail.claimForm.claimants.length > 0) {
      for (const claimant of state.claimDetail.claimForm.claimants) {
        if (claimant && claimant.clmtNo === state.claimDetail.claimForm.selectedClaimant.clmtNo) {
          claimant.clmItems = state.claimDetail.claimForm.selectedClaimant.clmItems
        }
      }
    }
  },
  [CLAIMS_CLAIMDETAIL_LEAVEQUOTE](state) {
    state.claimDetail.promptWhenExit = false
  },
  [CLAIMS_CLAIMDETAIL_PARAM](state, data) {
    // Note: Key - ignoreValue is reserved
    if (data) {
      const formatData = data
      let ignoreValue = data.ignoreValue
      if (ignoreValue === undefined) {
        ignoreValue = false
      }
      Object.keys(formatData).forEach(function (key) {
        if (key !== 'ignoreValue') {
          const arr = formatData[key]
          if (arr) {
            if (Array.isArray(arr)) {
              // Make it so that its value - label (easier to search)
              arr.map(obj => {
                if (!ignoreValue) {
                  obj.label = obj.value + ' - ' + obj.label
                }
              })
            }
            // Initially was using the Object.assign below
            // But due to vue js reactive caveats, we will use Vue.set instead
            Vue.set(state.claimDetail.claimParam, key, arr)
          }
        }
      })
    }
  },
  [CLAIMS_CLAIMDETAIL_PARAM_NOL1](state, data) {
    if (data.data && data.data.length > 0) {
      // Make it so that its value - label (easier to search)
      data.data.map(obj => {
        obj.label = obj.value + ' - ' + obj.label
      })
    }
    state.claimDetail.claimParam.nol1.data = data.data
    state.claimDetail.claimParam.nol1.menu = data.menu
  },
  [CLAIMS_CLAIMDETAIL_PARAM_RESERVE_LOADING](state) {
    state.claimDetail.claimParam.reserveInit = 0
  },
  [CLAIMS_CLAIMDETAIL_PARAM_RESERVE](state, data) {
    state.claimDetail.claimParam.reserve = clone(data)

    state.claimDetail.claimParam.reserveInit = 1
  },
  [CLAIMS_CLAIMDETAIL_PARAM_RESERVE_FAIL](state) {
    state.claimDetail.claimParam.reserveInit = 2
  }
}

const commitIntClmhdr = (state, data) => {
  const { commonForm } = state.claimDetail
  commonForm.clmRefNo = data.clmRefNo
  commonForm.proposalNo = data.proposalNo
  commonForm.revision = data.revision
  commonForm.appID = data.appID
  commonForm.intermediary = data.inter
  commonForm.product = data.product
  commonForm.scheme = data.scheme
  commonForm.planNo = data.planNo
  commonForm.startDate = data.comDate
  commonForm.endDate = data.expDate
  commonForm.acceptDate = data.acceptDate
  commonForm.polNo = data.polNo
  commonForm.busCls = data.busCls
  commonForm.appSalutation = data.appSalutation
  commonForm.appName = data.appName
  commonForm.lossDate = data.lossDate
  commonForm.notDate = data.notDate
  commonForm.ackDate = data.ackDate
  commonForm.reqDate = data.reqDate
  commonForm.recDate = data.recDate
  commonForm.lossPlace = data.lossPlace
  commonForm.riskNo = data.riskNo
  commonForm.itemNo = data.itemNo
  commonForm.cseLoss1 = data.cseLoss1
  commonForm.cseLoss2 = data.cseLoss2
  commonForm.cseLoss3 = data.cseLoss3

  const { commonInfo } = state.claimDetail
  commonInfo.statusCode = data.status
  commonInfo.statuses = data.statuses
  commonInfo.intermediaryName = data.interName
  commonInfo.productDesc = data.productDesc
  commonInfo.busClsDesc = data.busClsDesc
  commonInfo.cover = data.cover
  commonInfo.coverTypeDesc = data.coverTypeDesc
  commonInfo.vehMake = data.vehMake
  commonInfo.vehMakeDesc = data.vehMakeDesc
  commonInfo.vehModel = data.vehModel
  commonInfo.vehModelDesc = data.vehModelDesc
  commonInfo.vehRegno = data.vehRegNo
  commonInfo.engineNo = data.engineNo
  commonInfo.chassisNo = data.chassisNo
  commonInfo.reqDate = data.reqDate
  commonInfo.recDate = data.recDate
  commonInfo.lossPlace = data.lossPlace
  commonInfo.travelType = data.travelType
  commonInfo.tripType = data.tripType
  commonInfo.travelArea = data.travelArea
  commonInfo.travelAreaDesc = data.travelAreaDesc
  commonInfo.schemeDesc = data.schemeDesc
  commonInfo.planDesc = data.planDesc
}

const commitIntClmtDet = (state, data) => {
  const { claimForm } = state.claimDetail

  if (data.claimants && data.claimants.length > 0) {
    claimForm.claimants = data.claimants
  } else {
    claimForm.claimants = []
  }
  // Claim Item is inside Claimant
  // Claim Reserves is inside Claim Item
}
